export const payManageAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }